import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ListLine } from "../framework/listLine";
import { IMessageListItem } from "../../models/message/messageListItem";
import { Translations } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/translations";

export interface IMessageListStateColProp {
    item: IMessageListItem;
}

export class MessageListStateCol extends React.Component<IMessageListStateColProp, {}> {
    render() {
        const nowDate = Date.now();
        const item = this.props.item;
        return (
            <div className="flex WithIcons jend">
                {(nowDate - item.modifyDate) <= Base.oneHourInMs &&
                    <span className="icon fresh" title={Translations.RecentlyUpdated}></span>
                }
                {(!item.isRead && !item.requiresReceiptIsRead) &&
                    <span className="icon newItem" title={Translations.Unread}></span>
                }
                <span className={"stateText message state" + item.getStateNumber().toString(10)}>{item.getStateStr()}</span>
            </div>
        );
    }
}

//MessageListLine
export interface IMessageListLineProp {
    item: IMessageListItem;
    selected: boolean;
    first: boolean;
    isLastOpenedMessage: boolean;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
    onRefreshList: () => void;
}

export class MessageListLine extends React.Component<IMessageListLineProp, {}> {
    render() {
        const item = this.props.item;
        if (item.isTitle) {
            return (
                <ListLine
                    id={item.id}
                    first={this.props.first}
                    selected={false}
                    classes={"line dataTitle"}
                    onClick={(id: string) => {}}
                    onLongPress={(id: string) => {}}
                    onRefreshList={this.props.onRefreshList}>
                    <div className="row">
                        <div className="col col-12">{item.title}</div>
                    </div>
                </ListLine>
            );
        }
        return (
            <ListLine
                id={item.id}
                first={this.props.first}
                selected={this.props.selected}
                classes={"line" + (this.props.selected ? " selected" : "") + (this.props.isLastOpenedMessage ? " lom" : "")}
                onClick={this.props.onClick}
                onLongPress={this.props.onLongPress}
                onRefreshList={this.props.onRefreshList}>
                <div className="row">
                    <div className="col col-9">
                        <span className="bold">
                            {item.title}
                        </span>
                    </div>
                    <div className="col col-3 ra">{Base.timeToDateStr(item.date)}</div>
                </div>
                <div className="row sub">
                    <div className="col col-5">{(!Base.isNullOrEmpty(item.userCompanyName) ? item.userCompanyName + " / " : "") + item.userName}</div>
                    <div className="col col-7"><MessageListStateCol item={item} /></div>
                </div>
            </ListLine>
        );
    }
}